import script from "./SearchFacetColors.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFacetColors.vue?vue&type=script&lang=ts&setup=true"

import "./SearchFacetColors.vue?vue&type=style&index=0&id=524f005a&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524f005a"]])

export default __exports__